export default __webpack_public_path__ + "static/media/icon-distribution-logs.87a97cce.svg";